var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.headerState)?_c('header-menu',{attrs:{"logo":_vm.logoUrl}}):_vm._e(),(!_vm.loginModal.show)?_c('router-view'):_vm._e(),(_vm.loginModal.show)?_c('div',{staticClass:"seat_box"}):_vm._e(),_c('foot-menu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }